import styled from 'styled-components';
import { colors } from "../../utils/colors";
import backgroundPattern from '../../assets/home/BD-PATTERN.png'

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: ${(props) => props.adminPanel ? 'flex-start' : 'center'};
    margin-top: ${(props) => props.marginTop ? '100px' : ''};
    flex-direction: column;
    padding: 100px 60px 100px;
    background: url(${backgroundPattern});
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1200px) {
            padding: ${(props) => props.adminPanel ? '60px' : '100px'} 40px ${(props) => props.adminPanel ? '60px' : '100px'};
    }

    @media (max-width: 800px) {
            padding: ${(props) => props.adminPanel ? '40px' : '100px'} 20px ${(props) => props.adminPanel ? '40px' : '100px'};
    }
`;

export const QuestionWrapper = styled.div`
    width: 90%;
    margin-top: 50px;
`;

export const QuestionTittle = styled.h1`
    font-family: 'Courgette', cursive;
    color: ${colors.BLUE};
    text-align: center;
`;

export const QuestionImage = styled.img`
    max-width: 500px;
    width: 50%;
    margin: 25px 0 10px 10px;
    float: right;

    @media (max-width: 800px) {
        float: none;
        width: 90% !important;
    }
`;

export const QuestionP = styled.p`
    font-family: 'Courgette', cursive;
    margin-top: 25px;
    color: ${colors.BLUE};
`;

export const AnswerP = styled.p`
    font-family: 'Markazi Text', serif;
    color: ${colors.CREAM};
`;